package top.wcpe.allincore.ui.runtime.event

import kotlin.jvm.JvmName

/**
 * 值变更事件，用于受控组件（TextField/Slider/Checkbox 等）回调。
 *
 * 类型参数 [T] 的上界为可空 `Any?`，与原 Java 记录的平台类型语义一致，消费方可承载 null 值。
 *
 * @param T 值类型
 * @property oldValue 旧值
 * @property newValue 新值
 */
data class ChangeEvent<T>(
    // 保留 Java 记录式访问器 ABI：消费方以 `event.newValue()` 方法式调用
    @get:JvmName("oldValue") val oldValue: T,
    @get:JvmName("newValue") val newValue: T,
)
